<div class="home">
    <div class="row mb-2 mb-md-4">
        <div class="col-12 filter d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
            <div class="wallet-overview">
                <h3 class="filter-text-primary mb-2 mb-md-0 me-4">Wallet Overview</h3>
                <div class="currency-filter">
                    <mat-chip-listbox aria-label="wallet-selection">
                        <mat-chip-option
                            *ngFor="let wallet of ['USD', 'IQD']"
                            [value]="wallet"
                            [selected]="selectedWallet?.currency === wallet"
                            (click)="changeWallet(wallet)"
                        >
                            {{ wallet }}
                        </mat-chip-option>
                    </mat-chip-listbox>
                </div>
            </div>

            <!-- <div class="month-filter">
                <div class="w-100">
                    <app-value-field [editMode]="true">
                        <app-value-field-select
                            *ngIf="walletForm.controls.duration"
                            [controlDisplayName]="'Transactions Duration'"
                            [control]="walletForm.controls.duration"
                            appValueField="editField"
                            placeholder="Select duration"
                        >
                            <ng-template [appValueFieldOption]="currentDate">
                                <span>{{ currentDate | date : 'MMM yyyy' }}</span>
                            </ng-template>
                        </app-value-field-select>
                    </app-value-field>
                </div>
            </div> -->
        </div>
    </div>

    <div class="row">
        <div class="col-lg-6 col-12 ps-0 pe-0 pe-lg-4">
            <div class="d-flex flex-wrap justify-content-around gap-3">
                <div class="avb-balance mb-2 mb-lg-0 d-flex flex-column align-items-between justify-content-around" style="flex: 1">
                    <div class="d-flex justify-content-start align-items-center">
                        <div class="wallet-icon">
                            <mat-icon svgIcon="wallet"></mat-icon>
                        </div>
                    </div>

                    <div class="d-flex flex-wrap gap-3 justify-content-between align-items-center">
                        <div>
                            <span class="avb-balance-text-secondary">Available Balance in {{ selectedWallet.currency }}</span>
                            <p class="avb-balance-text-primary">
                                {{ selectedWallet.balance | number : (selectedWallet?.currency?.toUpperCase() === 'USD' ? '1.2-2' : '1.3-3') }}
                            </p>
                        </div>
                        <button mat-button class="btn-topup rounded-pill p-3" (click)="redirectToWalletTransfer()">
                            <mat-icon svgIcon="cash-in"></mat-icon>
                            Top-up
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-12 ps-0 pe-0">
            <div class="topup-spending d-flex align-items-center justify-content-around mb-2 mb-lg-0" style="flex: 1">
                <div class="d-flex flex-column align-items-center">
                    <mat-icon svgIcon="top-up"></mat-icon>
                    <p class="topup-spending-text-primary">N.A</p>
                    <span class="topup-spending-text-secondary">Total top up (Nov 2024)</span>
                </div>
                <div class="d-flex flex-column align-items-center">
                    <mat-icon svgIcon="spendings"></mat-icon>
                    <p class="topup-spending-text-primary">N.A</p>
                    <span class="topup-spending-text-secondary">Top up count</span>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="mt-4 col-12 transactions">
            <p class="transactions-text-primary my-3">Recent Transactions</p>
            <div class="today-section">
                <span class="transactions-text-secondary me-2">Last 50 Transactions</span>
                <div class="today-line"></div>
            </div>
            <app-spinner [isLoading]="transactionLoading" />
            <div *ngFor="let transaction of transactions">
                <div class="transaction-container py-4">
                    <div class="d-flex justify-content-center align-items-center">
                        <span class="username-badge me-2" *ngIf="transaction.receiver_name">{{ getInitials(transaction.receiver_name) }}</span>
                        <span class="username-badge me-2" *ngIf="!transaction.receiver_name"><mat-icon svgIcon="cash-in"></mat-icon> </span>
                        <div class="transaction-details">
                            <h6 class="transaction-header mb-0" [class.error-message]="transaction.status_code !== '0000'">
                                {{ transaction.transaction_type === transactionType.WALLET_CREDIT ? agentName : transaction.receiver_name || transaction.user_id }}
                            </h6>
                            <p class="transaction-subheader mb-0" [class.error-message]="transaction.status_code !== '0000'">
                                {{ transaction.status_code !== '0000' ? 'Transaction Failed' : (transaction.transaction_type | transactionType) }} •
                                {{ transaction.transaction_timestamp | date : 'dd MMM yyyy' }}
                            </p>
                        </div>
                    </div>

                    <div class="ps-1">
                        <p class="transaction-amount" [class.error-message]="transaction.status_code !== '0000'">
                            {{ transaction.transaction_amount | currency : transaction.transaction_currency : '' }} {{ transaction.transaction_currency }}
                        </p>
                        <p class="transaction-credit"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
